
import qs from 'qs'
import Axios from 'axios'
import { getInitSessionId } from './util'
const env = process.env

// 设置baseURL
Axios.defaults.baseURL = process.env.API_HOST
// 设置token值
// Axios.defaults.headers.common['token'] = token
// 请求头
Axios.defaults.headers.post['Content-Type'] = 'application/json'

// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
//   if (config.method !== 'get' && config.method !== 'delete' && config.url.indexOf('/tvpver/add') === -1 && config.url.indexOf('/tvp/add') === -1 && config.url.indexOf('/tvp/edit') === -1 && config.url.indexOf('/file') === -1) {
//     config.data = qs.stringify(config.data)
//   }
    if(config.method == 'post'){
        config.params = qs.stringify(config.params)
    }
    
    // 自动添加 X-Session-Id 请求头
    const sessionId = window.localStorage.getItem('xiaoyou_session_id')
    if (sessionId) {
      config.headers = config.headers || {}
      config.headers['X-Session-Id'] = sessionId
    }
    
  return config
}, function (error) {
  // 对请求错误做些什么
  console.log('错误的传参',error)
  return Promise.reject(error)
})

// 添加响应拦截器
// Axios.interceptors.response.use(function (response) {
//   // 对响应数据做点什么
//   return response;
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

function request (data) {
  return new Promise((resolve, reject) => {
    Axios({
      method: data.method,
      url: data.url,
      params: data.params,
      data: data.data,
      headers: data.headers
    }).then(res => {
      // if (res.data.code === 0) {
        resolve(res.data)
        if(res.data.code == 401){
          initSessionId()
        }
      // } else if (res.data.code === 401) {
      //   window.localStorage.removeItem('token')
      //   window.localStorage.removeItem('username')
      //   window.localStorage.removeItem('userId')
      //   window.localStorage.removeItem('role_id')
      //   location.reload()
      // } else {
      //   reject(res.data.msg)
      // }
    }).catch(error => {
      console.log('请求失败')
      console.log(error)
    })
  })
}
function initSessionId() {
      // 检查是否已有sessionId
      
      // 获取新的sessionId
      console.log('正在初始化sessionId...')
      getInitSessionId().then(sessionId => {
        console.log('sessionId初始化成功：', sessionId)
      }).catch(error => {
        console.error('sessionId初始化失败：', error)
        // 初始化失败不影响其他功能，只是握手功能会受影响
      })
    }
function uploadFileRequest({ url, formData, headers = {}, timeout = 30000, params, onProgress }) {
  return new Promise((resolve, reject) => {
    Axios({
      method: 'post',
      url,
      data: formData,
      params,
      // 不强制设置 Content-Type，交由浏览器自动添加 boundary；并显式覆盖默认的 application/json
      headers: { ...(headers || {}), 'Content-Type': 'multipart/form-data' },
      // 上传进度回调（浏览器环境）
      onUploadProgress: (progressEvent) => {
        try {
          const { loaded, total } = progressEvent || {}
          if (typeof total === 'number' && total > 0) {
            const percent = Math.min(100, Math.round((loaded / total) * 100))
            if (typeof onProgress === 'function') onProgress(percent, progressEvent)
          } else {
            // 无法计算总长度时，给一个占位的进度 0，完成时会自动到 100
            if (typeof onProgress === 'function') onProgress(0, progressEvent)
          }
        } catch (_) {}
      },
      timeout
    }).then(res => {
      resolve(res.data)
      if (res.data && res.data.code == 401) {
        initSessionId()
      }
    }).catch(error => {
      console.log('文件上传请求失败')
      console.log(error)
      reject(error)
    })
  })
}
export default {
  env,
  config: {},
  request,
  uploadFileRequest,
  uploadFileFetch
}

// 使用原生 fetch 进行文件上传（支持 FormData、超时控制、可选自定义头）
// 注意：当 body 是 FormData 时，不要手动设置 'Content-Type': 'multipart/form-data'，浏览器会自动带上 boundary
function uploadFileFetch({ url, formData, headers = {}, timeout = 30000, params, method = 'POST', withCredentials = false, responseType = 'json' }) {
  return new Promise((resolve, reject) => {
    try {
      // 组装查询参数
      let finalUrl = url
      if (params) {
        const qsStr = typeof params === 'string' ? params : qs.stringify(params)
        finalUrl = url.indexOf('?') >= 0 ? `${url}&${qsStr}` : `${url}?${qsStr}`
      }

      // 当 body 是 FormData 时，移除手动设置的 Content-Type，避免缺少 boundary
      const hdrs = { ...(headers || {}) }
      if (hdrs['Content-Type'] && String(hdrs['Content-Type']).includes('multipart/form-data')) {
        delete hdrs['Content-Type']
      }

      // 超时控制
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
      let timer = null
      if (controller && timeout && timeout > 0) {
        timer = setTimeout(() => {
          controller.abort()
        }, timeout)
      }

      fetch(finalUrl, {
        method: method || 'POST',
        body: formData,
        headers: hdrs,
        credentials: withCredentials ? 'include' : 'same-origin',
        signal: controller ? controller.signal : undefined
      })
        .then(async (resp) => {
          if (timer) clearTimeout(timer)
          if (!resp) return reject(new Error('无响应'))
          if (!resp.ok) {
            const text = await safeReadText(resp)
            const err = new Error(`HTTP ${resp.status}: ${text}`)
            err.status = resp.status
            err.body = text
            return reject(err)
          }
          // 尝试按需要的类型解析响应
          let data
          if (responseType === 'text') {
            data = await resp.text()
          } else if (responseType === 'blob') {
            data = await resp.blob()
          } else {
            // 默认按 JSON
            data = await safeReadJson(resp)
          }
          resolve(data)
        })
        .catch((error) => {
          if (timer) clearTimeout(timer)
          // 兼容超时错误
          if (error && (error.name === 'AbortError' || String(error.message).toLowerCase().includes('aborted'))) {
            const err = new Error('请求超时')
            err.code = 'ETIMEOUT'
            return reject(err)
          }
          reject(error)
        })
    } catch (e) {
      reject(e)
    }
  })
}

async function safeReadText(resp) {
  try {
    return await resp.text()
  } catch (e) {
    return ''
  }
}

async function safeReadJson(resp) {
  try {
    return await resp.json()
  } catch (e) {
    // 如果不是合法 JSON，回退为文本
    const text = await safeReadText(resp)
    return { raw: text }
  }
}



// WEBPACK FOOTER //
// ./src/https.js